<template>
  <transition enter-from-class="tw-opacity-0" leave-to-class="tw-opacity-0">
    <div v-if="show" :class="expired ? 'tw-bg-red-50 tw-border-red-200' : 'tw-bg-amber-50 tw-border-amber-200'"
      class="tw-border-b tw-border-solid tw-px-4 tw-py-3 tw-flex tw-items-center tw-justify-between tw-gap-3 tw-flex-wrap">
      <div class="tw-flex tw-items-center tw-gap-3">
        <icon :icon="expired ? 'solar:danger-triangle-bold-duotone' : 'solar:clock-circle-bold-duotone'"
          :class="expired ? 'tw-text-red-500' : 'tw-text-amber-500'" class="tw-text-2xl tw-shrink-0" />
        <p class="tw-text-sm tw-font-semibold" :class="expired ? 'tw-text-red-700' : 'tw-text-amber-700'">
          <template v-if="expired">
            {{ $t('subscriptions.banner.expired', 'Your subscription has expired. Renew to regain full access.') }}
          </template>
          <template v-else>
            {{ $t('subscriptions.banner.expiring', { days: status.days_remaining }) }}
          </template>
        </p>
      </div>
      <div class="tw-flex tw-items-center tw-gap-2">
        <a v-if="status.renew_url" :href="status.renew_url" target="_blank" rel="noopener"
          :class="expired ? 'tw-bg-red-500 hover:tw-bg-red-600' : 'tw-bg-amber-500 hover:tw-bg-amber-600'"
          class="tw-text-white tw-text-sm tw-font-semibold tw-px-4 tw-py-1.5 tw-rounded-md tw-duration-200">
          {{ $t('subscriptions.banner.renew', 'Renew now') }}
        </a>
        <button @click="dismissed = true" class="tw-text-gray-400 hover:tw-text-gray-600">
          <icon icon="solar:close-circle-bold-duotone" class="tw-text-xl" />
        </button>
      </div>
    </div>
  </transition>
</template>

<script setup>
import { ref, reactive, computed, onMounted } from 'vue';
import subscriptionsApi from '@/api/subscriptions';

const status = reactive({ has_active: false, expired: false, expiring_soon: false, days_remaining: 0, renew_url: null });
const dismissed = ref(false);

const expired = computed(() => status.expired && !status.has_active);
const show = computed(() => !dismissed.value && (expired.value || status.expiring_soon));

onMounted(async () => {
  try {
    const res = await subscriptionsApi.myStatus();
    Object.assign(status, res.data.data || {});
  } catch (e) { /* non-fatal: no banner */ }
});
</script>
